import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "juou-card" }

import {
  useBaseAsync,
  type HpsfirProTableColumn,
  type HpsfirProTableData,
  type HpsfirProTableFilter,
  type HpsfirProTableGetDataFunction,
  type HpsfirProFormItem,
} from 'hpsfir-managebase-ui';

import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import { normalizeBizTableColumns } from '@/utils/tableColumns';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const columns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([]));
const tableRef = ref<any>();

const addInitValue = {
};

const conditionsInitValue = {
};

const init = useBaseAsync(() => {
  columns.value = normalizeBizTableColumns([
    {
      name: 'sequenceNumber',
      label: '序号',
      type: 'number',
      isCondition: true,
      rule: [{ required: true, message: '请输入序号' }],
      width: 100,
    },
    {
      name: 'packageDays',
      label: '服务天数',
      type: 'number',
      isCondition: true,
      render(scope) {
        return `${scope?.row?.packageDays ?? ''}天`;
      },
      rule: [{ required: true, message: '请输入服务天数' }],
      width: 120,
    },
    {
      name: 'packageAmount',
      label: '价格',
      type: 'numberStr',
      isCondition: true,
      render(scope) {
        return `￥${scope?.row?.packageAmount ?? ''}`;
      },
      rule: [{ required: true, message: '请输入服务金额' }],
      width: 120,
    },
    {
      name: 'isHidden',
      label: '是否隐藏',
      type: 'select',
      options: [
        { label: '显示', value: 0 },
        { label: '隐藏', value: 1 },
      ],
      rule: [{ required: true, message: '请选择是否隐藏' }],
    },
    {
      name: 'createTime',
      label: '创建时间',
      type: 'string',
      hideEdit: true,
      hideCreate: true,
      width: 160,
    },
  ]);
});

const operates: any[] = [];

const loading = ref(false);

const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().packageApi.pagePackagepackage({
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '') {
          return conditions;
        }
        conditions[key] = val;
        return conditions;
      }, {} as any),
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
    });

    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您确定要删除"${row.packageAmount}元/${row.packageDays}天"的服务吗？此操作不可恢复，请谨慎操作。`;

const addFun = useBaseAsync(async(data: any) => {
  await useApi().packageApi.addPackagepackage({
    packageAdminVo: {
      ...data,
      packageAmount: String(data.packageAmount),
    },
  });
  ElMessage.success('添加成功');
});

const updateFun = useBaseAsync(async(data: any) => {
  await useApi().packageApi.updatePackagepackage({
    packageAdminVo: {
      ...data,
      packageAmount: String(data.packageAmount),
    },
  });
  ElMessage.success('修改成功');
});

const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().packageApi.delPackagepackage(data.id);
  ElMessage.success('删除成功');
});

init();

return (_ctx: any,_cache: any) => {
  const _component_HpsfirProTable = _resolveComponent("HpsfirProTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HpsfirProTable, {
      ref_key: "tableRef",
      ref: tableRef,
      "export-file-name": "增值服务",
      title: "增值服务",
      paginations: { pageSize: 10 },
      columns: columns.value,
      "get-data": _unref(getData),
      "on-add": _unref(addFun),
      "on-delete": _unref(deleteFun),
      "on-edit": _unref(updateFun),
      loading: loading.value,
      "is-dangder-delete": true,
      "format-dangder-delete-info": formatDeleteInfo,
      "row-key": "id",
      operates: operates,
      "add-init-values": addInitValue,
      "codition-init-values": conditionsInitValue
    }, null, 8, ["columns", "get-data", "on-add", "on-delete", "on-edit", "loading"])
  ]))
}
}

})